/*
 * @Author: qhy
 * @Date: 2023-03-28 22:26:02
 * @LastEditors: qhy
 * @LastEditTime: 2023-03-31 23:35:36
 * @Description: 
 */
import "babel-polyfill";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import axios from "axios";
import "animate.css";
import "material-design-icons-iconfont";
// import 'material-design-icons'
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/css/swiper.min.css"; // 根据实际路径和文件修改
import "./assets/font/font.css";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@mdi/font/css/materialdesignicons.css";
import "leaflet-draw/dist/leaflet.draw.css";
import "leaflet-draw/dist/leaflet.draw.js";
import turf from "turf";
import Antd from "ant-design-vue"
import 'ant-design-vue/dist/antd.css'
import doitUIWeb from 'doit-ui-web'
import 'doit-ui-web/lib/doituiweb.css'
import plLazy from "@/components/Maps/plLazy";

// import Viewer from 'v-viewer'
// import 'viewerjs/dist/viewer.css'



//v-viewer图片放大器
// Vue.use(Viewer, {
//     defaultOptions: {
//         zIndex: 9999
//     }
// })

Vue.prototype.GLOBAL = {
  CLUSTER:{//集群相关参数
    // RESOLUTION:0.00001073,//用于配置矢量图层和集群的临界点的分辨率
    RESOLUTION: 0.00034332275390625,//用于配置矢量图层和集群的临界点的分辨率
    DISTANCE: 100//集群的参数distance
  }
};

Vue.prototype.axios = axios;
Vue.use(turf);
Vue.config.productionTip = false;
Vue.use(VueAwesomeSwiper);
Vue.use(Antd)
Vue.use(doitUIWeb)
Vue.component('pl-lazy', plLazy);

//浏览器打印后端返回对象时数值不隐藏
Vue.prototype.print = (obj, type) => {
  type = type || "log";
  const log = JSON.parse(JSON.stringify(obj));
  console[type](log);
};
/* leaflet icon */
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

Vue.prototype.setCookie = function (cname, value) {
  if (value !== "") {
    localStorage.setItem(cname, value);
  } else {
    localStorage.removeItem(cname);
  }
};

Vue.prototype.getCookie = function (cname) {
  return localStorage.getItem(cname);
};

// region:sourceFrom 消费侧(仅读,不写入,不埋点)
// 同域名下 sourceFrom 由入口项目落地;本项目只读取并在注册提交时塞进请求体。
Vue.prototype.getSourceFrom = function () {
  const v = localStorage.getItem('sourceFrom');
  const exp = parseInt(localStorage.getItem('sourceFromExp') || '0', 10);
  if (v === 'baidu' && exp > 0 && Date.now() > exp) {
    localStorage.setItem('sourceFrom', '');
    localStorage.removeItem('sourceId');
    localStorage.removeItem('sourceFromExp');
    return '';
  }
  return v || '';
};

Vue.prototype.getSourceId = function () {
  const v = localStorage.getItem('sourceFrom');
  const exp = parseInt(localStorage.getItem('sourceFromExp') || '0', 10);
  if (v === 'baidu' && exp > 0 && Date.now() > exp) {
    localStorage.setItem('sourceFrom', '');
    localStorage.removeItem('sourceId');
    localStorage.removeItem('sourceFromExp');
    return '';
  }
  return v === 'baidu' ? (localStorage.getItem('sourceId') || '') : '';
};
// endregion:sourceFrom

Vue.prototype.openUrlInNewWindow = function (url) {
  let routeUrl = this.$router.resolve({
    path: url,
  });
  window.open(routeUrl.href, "_blank");
};

Vue.prototype.findRealParent = function (firstVueParent) {
  let found = false;
  while (firstVueParent && !found) {
    if (firstVueParent.main === undefined) {
      firstVueParent = firstVueParent.$parent;
    } else {
      found = true;
    }
  }
  return firstVueParent;
};
Vue.prototype.bus = new Vue();
new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
  // mounted () {
  //   document.dispatchEvent(new Event('render-event'))
  // }
}).$mount("#app");
